import { Radio } from 'antd';
import styled from 'styled-components';

import { Flex, Space, VFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import { getAlphaColor } from '@/styles/colors/color.utils';

import type { ImportRuleT, ImportTemplateT } from '../providers/types/types';

type Props = {
  importRule: ImportRuleT;
  template: ImportTemplateT;
  setImportRule: (i: ImportRuleT) => void;
};

const InboundImportOptions = ({
  template,
  importRule,
  setImportRule,
}: Props) => {
  return (
    <VFlex>
      <Typo type="label2" weight="sb">
        Inbound/outbound messages
      </Typo>
      <Space h={16} />
      <Radio.Group
        value={importRule.bound}
        onChange={(e) =>
          setImportRule({ ...importRule, bound: +e.target.value })
        }
      >
        <Flex g={16}>
          <Radio value={template.bound.all[0]}>
            <Flex g={16} a="center">
              <Typo type="label2">{template.bound.all[1]}</Typo>
              <Default a="center" j="center">
                default
              </Default>
            </Flex>
          </Radio>
          <Radio value={template.bound.inbound[0]}>
            {template.bound.inbound[1]}
          </Radio>
          <Radio value={template.bound.outbound[0]}>
            {template.bound.outbound[1]}
          </Radio>
        </Flex>
      </Radio.Group>
    </VFlex>
  );
};

export default InboundImportOptions;

const Default = styled(Flex)`
  border-radius: 4px;
  height: 22px;
  width: 51px;
  background-color: ${(props) =>
    getAlphaColor(props.theme.colors.primary100, 0.05)};
  color: ${(props) => props.theme.colors.primary100};
  font-size: 12px;
`;
